import DashboardEmptyStateCard from '../../DashboardEmptyStateCard';
import InquiryIcon from '@/public/images/dashboard/inquiry.svg';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function PendingLeadsEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={InquiryIcon}
      title={Trans(translations, 'HereYouWillSeeLeadsThatAreAboutToExpire')}
    />
  );
}

export default PendingLeadsEmptyState;
